import Vue from "vue";

import { Component, Prop } from "@/decorators";

@Component
export default class CpfCnpjComponent extends Vue {
    @Prop(String) id: string;
    @Prop(String) name: string;
    @Prop(String) value: string;

    private onBlur(value) {
        this.$emit("input", this.formatValueToModel(value));
    }

    // Letras são preservadas porque o CNPJ alfanumérico as utiliza nos 12 primeiros caracteres
    private formatValueToModel(value) {
        return value.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
    }
}
